module.exports = __webpack_public_path__ + "static/media/alert-tooltip.1626ba2b.svg";